export default __webpack_public_path__ + "static/P_SearchThumb_IP_Cam_Viewer-f0ca7539aeac98a5b2c97f83b42bf67c.webp";